<h1 mat-dialog-title>Add new Search Filter</h1>

<mat-dialog-content class="dialog-content">
  <gymfinder-search-filter
    [(searchFilter)]="searchFilter"
    [supportAddItem]="false"></gymfinder-search-filter>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button (click)="closeDialog()">Cancel</button>
  <button mat-raised-button color="primary" (click)="createFilter()">
    Create
  </button>
</mat-dialog-actions>
